import React from 'react';
import { preventMouseMove } from '../../../helpers/events';
import { sendGoal } from '../../../helpers/metrika';
import QuestionIcon from '../../../shared/components/Icons/Question';
import GOALS from '../../../constants/GOALS';
import useBasketSize from '../../../hooks/useBasketSize';
import Styled from './styled';

const HelpButton = () => {
  const { Widget } = window;
  const basketSize = useBasketSize();

  const handleClick = () => {
    if (Widget.helpController.state.isHidden) {
      Widget.helpController.show();
      sendGoal(GOALS.QUESTION_BUTTON);
    } else {
      Widget.helpController.hide();
      sendGoal(GOALS.UNDERSTAND_BUTTON);
    }
  };

  return (
    <Styled.HelpButton offset={basketSize} onClick={handleClick} onMouseMove={preventMouseMove}>
      <QuestionIcon />
    </Styled.HelpButton>
  );
};

export default HelpButton;
